export const hideSeek = () => {
    const $ = jQuery;

    const components = $('.hide-seek');
    const items = components.find('.accordion-item');

    if (components.length === 0) {
        return false;
    }

    const lotties = components.find('.lottie-wrapper');

    if ( lotties ) {
        const script = document.createElement('script');

        script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.7.6/lottie.min.js');

        document.body.appendChild(script);

        script.onload = () => {
            lotties.each((i, lottieWrapper) => {
                const lottiePath = $(lottieWrapper).data('lottie');
                
                bodymovin.loadAnimation({
                    container: lottieWrapper,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: lottiePath
                })
            });
        }
    }

    const autoAccordion = (clickedItem = false) => {
        if (clickedItem) {
            const itemComponent = $(clickedItem).parents('.hide-seek');
            clearInterval(window[itemComponent[0].id].autoInterval);

            const clickedComponentItems = itemComponent.find('.accordion-item');
            const clickedKey = $(clickedItem).data('item') * 1;
            let openMedia = itemComponent.find('.media-wrapper.open');
            let openKey = clickedKey;

            if ($(clickedItem).hasClass('open')) {
                $(clickedItem).removeClass('open');
                $(clickedItem).find('.accordion-content').slideUp();
                            
                clickedItem = $(clickedItem).next();
                openKey++;

                if (clickedItem.length === 0) {
                    clickedItem = clickedComponentItems.first();
                    openKey = 0;
                }
            } else {
                clickedComponentItems.removeClass('open');
                clickedComponentItems.find('.accordion-content').slideUp();
            }

            openMedia.fadeOut(400, () => {
                openMedia.removeClass('open');
                            
                const nextMedia = itemComponent.find('.media-wrapper[data-item=' + openKey + ']');

                nextMedia.fadeIn();
                nextMedia.addClass('open');
            });

            $(clickedItem).addClass('open');
            $(clickedItem).find('.accordion-content').slideDown();

            window[itemComponent[0].id].autoInterval = setInterval(() => {
                $(clickedItem).removeClass('open');
                $(clickedItem).find('.accordion-content').slideUp();
                
                clickedItem = $(clickedItem).next();
                openKey = $(clickedItem).data('item') * 1;

                if (clickedItem.length === 0) {
                    clickedItem = clickedComponentItems.first();
                    openKey = 0;
                }

                openMedia = itemComponent.find('.media-wrapper.open');

                openMedia.fadeOut(400, () => {
                    openMedia.removeClass('open');
                                
                    const nextMedia = itemComponent.find('.media-wrapper[data-item=' + openKey + ']');
    
                    nextMedia.fadeIn();
                    nextMedia.addClass('open');
                });
                
                $(clickedItem).addClass('open');
                $(clickedItem).find('.accordion-content').slideDown();
            }, 10000);
        } else {
            components.each( (i, component) => {
                if (!$(component).hasClass('auto')) {
                    $(component).addClass('auto');
                    
                    const componentItems = $(component).find('.accordion-item');
                    const mediaItems = $(component).find('.media-wrapper');
                    let activeItem = componentItems.first();
                    let mediaKey = 0;

                    $(activeItem).addClass('open');
                    $(activeItem).find('.accordion-content').slideDown();
                    $(mediaItems[mediaKey]).addClass('open');
                    $(mediaItems[mediaKey]).fadeIn();

                    window[component.id].autoInterval = setInterval(() => {
                        $(activeItem).removeClass('open');
                        $(activeItem).find('.accordion-content').slideUp();
                        $(mediaItems[mediaKey]).fadeOut(400, () => {
                            $(mediaItems[mediaKey]).removeClass('open');
                            mediaKey++;
                            if (mediaKey === mediaItems.length) {
                                mediaKey = 0;
                            }
                            $(mediaItems[mediaKey]).fadeIn();
                        });
                        
                        activeItem = $(activeItem).next();
                        

                        if (activeItem.length === 0) {
                            activeItem = componentItems.first();
                        }
                        
                        $(activeItem).addClass('open');
                        $(activeItem).find('.accordion-content').slideDown();
                    }, 10000);
                }
            });
        }
    };

    autoAccordion();

    $(items).find('.accordion-header').each((i, header) => {
        $(header).on('click', () => {
            const item = $(header).parent();

            if (item.length === 1) {
                autoAccordion(item[0]);
            }
        });
    });
};